import "./SystemMessage.scss";

interface Props {
  text: string;
}

export const SystemMessage = ({ text }: Props) => {
  return <div className="system-message">{text}</div>;
};
